import { createAsyncThunk } from "@reduxjs/toolkit";
import { SessionManager } from "utils";

// The customer portal has no logout API (its "Log Out" only clears local
// session data), so sign-out is client-side only.
export const signOut = createAsyncThunk('signOut', async () => {
    SessionManager.clearAll();
    return { status: 200 }
})
